<template>
    <div>
        <div class="videoView">
            <video src="../../../assets/video/rewenshi.mp4" controls muted="true" poster="../../../assets/video/rewenshi-poster.jpg" />
        </div>
        <div class="link-content">
            <div class="toLanMao">
                <img src="../../../assets/images/shipin.jpg" /> <a href="javascript:void(0)" @click="toLanMao">蓝猫淘气三千问解释什么是温室效应</a>
            </div>
            <div class="toText">
                <img src="../../../assets/images/wenben.jpg" /> <a href="javascript:void(0)" @click="toText">文字版</a>
            </div>
            <div class="clear"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "IndexVideo",
        methods: {
            toLanMao: function () {
                this.$emit('onIndexChanged',2);
            },
            toText: function () {
                this.$emit('onIndexChanged',3);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .videoView {
        video {
            width: 80%;
            margin-left: 10%;
        }
        width: 100%;
    }
    .link-content {
        margin-top: 10%;
        margin-left: 10%;
        width: 80%;
        img {
            width: 50px;
            height: 50px;
        }
        .toLanMao {
            float: left;
        }
        .toText {
            float: right;
        }
        a {
            font-size: 15px;
            color: #008000;
            text-decoration: none;
        }
    }
</style>